import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Philosophy() {
  const { ref: sectionRef, isVisible } = useScrollAnimation();
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation();

  return (
    <section id="philosophy" className="py-16 sm:py-20 lg:py-24 xl:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 xl:gap-16 items-center">
          {/* Left Content */}
          <div
            ref={sectionRef as React.RefObject<HTMLDivElement>}
            className={`lg:col-span-2 animate-fade-left ${isVisible ? 'in-view' : ''}`}
          >
            <p className="text-amber-700 text-xs sm:text-sm uppercase tracking-widest mb-3 sm:mb-4">(Our Philosophy)</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl mb-4 sm:mb-6 leading-tight">
              <span className="block text-gray-900 font-bold">For Centuries,</span>
              <span className="block text-gray-500 font-light">Europe's Elite Gathered</span>
            </h2>
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
              The Grand Salon Society revives this tradition — presenting world-class musicians in curated, one-hour concert experiences designed exclusively for your home.
            </p>
            <div className="space-y-3 sm:space-y-4 mb-8 sm:mb-10">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-amber-600 text-lg sm:text-xl mt-1 flex-shrink-0"></i>
                <p className="text-gray-800 text-sm sm:text-base lg:text-lg">Every program is thoughtfully selected.</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-amber-600 text-lg sm:text-xl mt-1 flex-shrink-0"></i>
                <p className="text-gray-800 text-sm sm:text-base lg:text-lg">Every detail is elevated.</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-amber-600 text-lg sm:text-xl mt-1 flex-shrink-0"></i>
                <p className="text-gray-800 text-sm sm:text-base lg:text-lg">Every performance is personal.</p>
              </div>
            </div>
          </div>

          {/* Right Images */}
          <div
            ref={rightRef as React.RefObject<HTMLDivElement>}
            className={`lg:col-span-3 relative animate-fade-right delay-200 ${rightVisible ? 'in-view' : ''}`}
          >
            <div className="grid grid-cols-2 gap-4 sm:gap-6">
              <div className="col-span-1 pt-8 sm:pt-12">
                <div className="w-full h-64 sm:h-72 lg:h-80 rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src="https://public.readdy.ai/ai/img_res/4b60a6b0462550a0efed20e8924b370f.jpg"
                    alt="Sheet Music"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="col-span-1">
                <div className="w-full h-72 sm:h-80 lg:h-96 rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src="https://readdy.ai/api/search-image?query=elegant%20cellist%20performing%20in%20luxurious%20home%20interior%20velvet%20chairs%20candlelight%20intimate%20classical%20concert%20warm%20amber%20lighting%20aristocratic%20setting%20refined%20atmosphere%20chamber%20music%20performance&width=600&height=900&seq=philosophy-img-2&orientation=portrait"
                    alt="Intimate Performance"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
